export default __webpack_public_path__ + "static/media/food3.dab399e3.jpg";